<template>
    <div class="NobleList">
        <div class="noble-item-box" :style="{backgroundImage: `url(${resultNobleImgBg('icon')})`}">
            <!-- <img class="noble-item-img" :src="resultNobleImgBg('icon')" /> -->
        </div>
        <div class="noble-item-desc" :style="{ backgroundImage: resultNobleImgBg() }">
            <div :class="['noble-item-text-title', language == 'ug' && 'noble-item-text-title-ug ug']">
                <img src="@/assets/noble/noble-icon01.png" alt="">
                <span>{{$t('xx贵族', { name: userNoble ? userNoble.levelName || $t('暂无任何') : $t('暂无任何') }) }}</span>
                <img src="@/assets/noble/noble-icon02.png" alt="">
            </div>
            <div :class="['noble-item-text-content', language == 'ug' && 'noble-item-text-content-ug']" >
                <p :class="['noble-item-text-content-score', language == 'ug' && 'noble-item-text-content-score-ug ug']">{{ $t('当前用户的贵族值为：xx', {value: userNoble ? userNoble.value : ''}) }}</p>
                <p v-if="userNoble.isMaxLevel">{{ $t('恭喜你，你已经是王者贵族了。') }}</p>
                <p v-else>{{ $t('贵族升级: xx贵族还需xx贵族值', {name: userNoble ? userNoble.nextLevelName : '' , value: userNoble ? userNoble.nextLevelDifference : '' })}}</p>
                <p class="noble-item-text-content-desc">{{ $t('送礼可获得贵族值，1钻石=1贵族值，累计达到对应贵族值可获得贵族等级。') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant';

export default {
    name: "NobleList",
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem
    },
    props: {
        noble: {
            type: Object,
            default: () => ({})
        },
        language: {
            type: String,
            default: 'ug'
        }
    },
    watch: {
        noble: {
            handler(val) {
                this.userNoble = val
            },
            deep: true
        }
    },
    data() {
        return {
            noboleList: [
                { img: require('@/assets/noble/noble-level0-img.png'), bgUrl: require('@/assets/noble/noble-level1-bg.png') },
                { img: require('@/assets/noble/noble-level1-img.png'), bgUrl: require('@/assets/noble/noble-level1-bg.png') },
                { img: require('@/assets/noble/noble-level2-img.png'), bgUrl: require('@/assets/noble/noble-level2-bg.png') },
                { img: require('@/assets/noble/noble-level3-img.png'), bgUrl: require('@/assets/noble/noble-level3-bg.png') },
                { img: require('@/assets/noble/noble-level4-img.png'), bgUrl: require('@/assets/noble/noble-level4-bg.png') },
                { img: require('@/assets/noble/noble-level5-img.png'), bgUrl: require('@/assets/noble/noble-level5-bg.png') },
            ],
            userNoble: {}
        }
    },
    methods: {
        resultNobleImgBg(type) {
            let blodImg = null
            blodImg = require('@/assets/noble/noble-level0-img.png')
            let blodBg = null
            blodBg = require('@/assets/noble/noble-level1-bg.png')
            if (Array.isArray(this.noboleList) && this.noboleList.length && this.noble.levelBgId !== undefined) {
                blodImg = this.noboleList[this.noble.levelBgId]?.img
                blodBg = this.noboleList[this.noble.levelBgId]?.bgUrl
            }
            return type === 'icon' ? `${blodImg}` : `url(${blodBg})`
        }
    },
}
</script>

<style lang="scss" scoped>
.NobleList {
    width: 100%;
    height: 100%;
    font-size: 14px;
    color: #EFD5E7;

    .noble-item-box {
        height: 158px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-size: 225px;
        background-repeat: no-repeat;
        background-position: center;
        transform: translateY(20px);
        // .noble-item-img {
        //     width: 257px;
        //     height: 198px;
        // }
    }

    .noble-item-desc {
        width: 100%;
        height: fit-content;
        border-radius: 20px 20px 20px 20px;
        padding: 12px 10px;
        box-sizing: border-box;
        background-size: cover;
        background-repeat: no-repeat;

        .noble-item-text-title {
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            font-size: 18px;
            text-align: center;

            img {
                width: 76px;
                height: 9px;
            }

            span {
                padding: 0 12px;
            }
        }
        .noble-item-text-title-ug {
            // justify-content: space-between;
            font-size: 14px;
            letter-spacing: 0;
        }
 
        .noble-item-text-content {
            padding-top: 12px;
            font-size: 12px;

            p {
                color: #B39CAC;
                line-height: 20px;
            }

            .noble-item-text-content-score {
                font-weight: 500;
                font-size: 14px;
                color: #EFD5E7;
            }

            .noble-item-text-content-score-ug {
                font-size: 12px;
            }

            .noble-item-text-content-desc {
                width: 100%;
                padding-top: 12px;
            }
        }
        .noble-item-text-content-ug {
            font-size: 11px;
        }
    }
}


.transition {
    transition: all 5s;
}
</style>